import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Banner } from '../../components';
import { Loader } from '../../components';
import {ArticlesHead} from  '../../components'
import {FeaturedCarousel} from '../../components'
import {ArticlesColumn} from '../../components'
import { BaseUrl } from "../../config";

const NewsIndexContainer = (props) => {
  const loader = useSelector((state) => state.loader);
  const [newsData, setNewsData] = useState([])
  const [tempNewsData, setTempNewsData] = useState([])
  const [featuredData, setFeaturedData] = useState([])

  useEffect(() => {
    // all articles
    fetch(`${BaseUrl}/page?key=invrsion&slug=index-news&page=index-news`, {
      method: 'GET',
      headers : { 
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
    }).then((json) =>  {
      console.log(json);
      setNewsData(json.data.index_news.list_news)
    })
    // featured articles
    fetch(`${BaseUrl}/page?key=invrsion&slug=featured&page=featured`, {
      method: 'GET',
      headers : { 
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
    }).then((json) =>  {
      setFeaturedData(json.data.index_news.list_news);
    })
    
  }, []);


  const arrayLoad = [
    require('../../assets/parallax-1.jpg')
  ]

  return (
    <React.Fragment>
      {
        newsData.length > 0 &&

        <ArticlesHead topArticles={newsData} />

      }

      {
        featuredData.length > 0 &&
        <FeaturedCarousel featuredData={featuredData} titleSection="Featured on" route="featured" />
      }
      {
        newsData.length > 0  &&
        <ArticlesColumn articles={newsData.slice(4, newsData.length)} slug="index-news" isIndex={true} />
      }
      {/* <Banner text="Want to dive deeper? Get your hands on our press kit" route="/contact" copyRoute="Discover" isDownload={true}/> */}
      <Loader isFetching={newsData.length > 0}  arrayLoad={arrayLoad} />
    </React.Fragment>
  );
};

export default NewsIndexContainer;
